import { render, staticRenderFns } from "./ScrollShadow.vue?vue&type=template&id=6b16440e&"
import script from "./ScrollShadow.vue?vue&type=script&lang=js&"
export * from "./ScrollShadow.vue?vue&type=script&lang=js&"
import style0 from "./ScrollShadow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports